<template>
    <div>
        <card-header title="Edit User" icon="fa-pencil" />

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-align-left" title="Account Information" />

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label-position="inside">
                                <template #label>First Name <span class="required-flag">*</span></template>
                                <b-input v-model="user.first_name"></b-input>
                            </b-field>
                        </div>
                        <div class="column is-7">
                            <b-field label-position="inside">
                                <template #label>Last Name <span class="required-flag">*</span></template>
                                <b-input v-model="user.last_name"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-field label-position="inside">
                                <template #label>Maiden Name</template>
                                <b-input v-model="user.maiden_name"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label-position="inside">
                                <template #label>Date of Birth <span class="required-flag">*</span></template>
                                <b-input v-model="user.dob" v-mask="'##/##/####'" placeholder="mm/dd/yyyy"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>

                <subheader-list-item icon="fa-align-left" title="Login Information" />

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Primary E-Mail Address" label-position="inside">
                                <b-input v-model="user.email"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Secondary E-Mail Address" label-position="inside">
                                <b-input v-model="user.email_2"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Password" label-position="inside">
                                <b-input placeholder="Set to change password..." v-model="user.password" autocomplete="off"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>

                <subheader-list-item icon="fa-align-left" title="Contact Information" />

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column is-7">
                            <b-field label="Address" label-position="inside" message="Number, street, etc.">
                                <b-input v-model="user.address"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Address 2" label-position="inside" message="Appt. Number, Suite, etc.">
                                <b-input v-model="user.address_2"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-field label="City" label-position="inside">
                                <b-input v-model="user.city"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="State" label-position="inside">
                                <b-select name="state" expanded v-model="user.state">
                                    <option value="AL">Alabama</option>
                                    <option value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA" selected=""> Washington</option>
                                    <option value="DC">Washington D.C.</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Zip" label-position="inside">
                                <b-input v-model="user.zip"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <hr />
                    <div class="columns">
                        <div class="column">
                            <b-field label="Home (Cell) Phone" label-position="inside">
                                <b-input v-model="user.phone"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Work Phone" label-position="inside">
                                <b-input v-model="user.phone_2"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>

                <subheader-list-item icon="fa-align-left" title="Additional Information" />

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column-is-narrow"><i class="far fa-fw"></i></div>

                        <div class="column">
                            <b-field label="School District" label-position="inside">
                                <b-input v-model="user.district"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="School" label-position="inside">
                                <b-input v-model="user.school"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column-is-narrow"><i class="far fa-fw"></i></div>

                        <div class="column is-8">
                            <b-field label="Subject Area" label-position="inside">
                                <b-input v-model="user.subject_area"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Grade Level" label-position="inside">
                                <b-input v-model="user.grade_level"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>

            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click=""><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete User?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!user.first_name || !user.last_name || !user.email"
                    ><i class="fas fa-check mr-2"></i>Save User
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardToolbar from "../../components/common/CardToolbar";
    import {client as http} from '../../http_client';
    import CardFooter from "@/components/common/CardFooter";
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import moment from "moment";

    export default {
        components: {ContainerListItem, SubheaderListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                user: {},
                confirmDelete: false
            };
        },
        methods: {
            loadUser: function () {
                this.$emit('loading', true);
                http.get('users/' + this.props.userId).then(response => {
                    this.user = response.data;
                    this.user.dob = moment.utc(this.user.dob).format('MM/DD/YYYY');
                    // this.$emit('title', this.user.first_name + ' ' + this.user.last_name + ' (' + this.user.id + ')');
                    this.$emit('loading', false);
                });
            },
            submit: function () {
                http.put('users/' + this.props.userId, {
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    maiden_name: this.user.maiden_name,
                    password: this.user.password,
                    dob: this.user.dob,
                    email: this.user.email,
                    email_2: this.user.email_2,
                    address: this.user.address,
                    address_2: this.user.address_2,
                    city: this.user.city,
                    state: this.user.state,
                    zip: this.user.zip,
                    phone: this.user.phone,
                    phone_2: this.user.phone_2,
                    district: this.user.district,
                    school: this.user.school,
                    subject_area: this.user.subject_area,
                    grade_level: this.user.grade_level
                }, {force: true}).then(response => {
                    this.$reloadCard('user-details', {userId: this.props.userId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the user.');
                    this.$emit('loading', false);
                });
            }
        },
        mounted: function () {
            this.loadUser();
        }
    };
</script>

<style>

</style>
